import Chip from '@mui/material/Chip';

export default ({
  id,
  onMouseDown,
  disabled,
  counter
}: {
  counter: number;
  disabled: boolean;
  id: string;
  onMouseDown: (e: React.MouseEvent) => void;
}) => {
  return (
    <Chip
      id={id}
      onClick={onMouseDown}
      label={counter}
      disabled={disabled}
      sx={{
        position: 'absolute',
        bottom: '5px',
        right: '5px',
        color: counter ? 'black' : 'red'
      }}
    />
  );

};
